<template>
  <div>
    <Modal
         v-model="isShow"
        :title="title"
        :footer-hide="true"
        width="500"
        :mask-closable="false"
        class="codebox"
        @on-cancel="cancel">
        <div id="qrcode"></div> <!-- 创建一个div，并设置id为qrcode -->
        <p>支付成功以后3秒内关闭</p>
    </Modal>

  </div>
</template>

<script>
import QRCode from 'qrcodejs2'  // 引入qrcode
export default {
  props:['title','url'],
  data () {
      return {
        isShow:false,
      }
  },
  mounted () {
    this.isShow=this.url?true:false
    this.qrcode();
  },
  methods: {
    qrcode() {
      let qrcode = new QRCode('qrcode', {
        width: 200,
        height: 200,
        text: this.url, // 二维码地址
        colorDark : "#000",
        colorLight : "#fff",
      })
    },
    cancel(){
      this.$emit('fun',"");
      this.isShow=false;
    }
  }
}
</script>
<style scoped>
  .codebox{text-align: center;}
  #qrcode{display: inline-block;}
  
</style>



// WEBPACK FOOTER //
// src/components/code.vue